import styled from 'styled-components';
import { TableHeader as TableHeaderUi } from 'ui/tableHeader';
import { spacing } from 'ui/theme';
import { useSimpleIndexContext } from './contexts';

const StyledTableHeader = styled(TableHeaderUi)`
  [data-test='full-width'] & {
    [role='columnheader'] {
      &:first-child {
        padding-left: ${spacing.layoutLRPadding};
      }

      &:last-child {
        padding-right: ${spacing.layoutLRPadding};
      }
    }
  }
`;

type Props = {
  rowsColumns: any[];
};

export const TableHeader = ({ rowsColumns }: Props) => {
  const { sortedBy, setSortedBy, sortDirection, setSortDirection } = useSimpleIndexContext();

  return (
    <StyledTableHeader
      columns={rowsColumns}
      sortedBy={sortedBy as string}
      setSortedBy={setSortedBy}
      sortDirection={sortDirection}
      setSortDirection={setSortDirection}
    />
  );
};
